import { useEffect } from 'react';

const useKeydown = (handleKeyDown: (event: any) => void) => {
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });
};

export default useKeydown;
